// Node Modules
import axios from 'axios';

/**
 * NEWSの記事一覧を取得
 * @param {String} rootPath ルートパス
 * @param {Number} perPage 取得する件数
 * @param {String} taxonomy タクソノミー名
 * @param {Number} catId カテゴリで絞る場合はカテゴリID
 * @param {Number} offset スキップする件数
 * @returns 
 */
const getNewsList = async (rootPath, perPage, taxonomy, catId = null, offset = 0) => {
    return new Promise((resolve, reject) => {
        // WP REST APIのURL
        const url = `${rootPath}/wp-json/wp/v2/news`;

        // パラメータ
        const config = {
            params: {
                _fields: `id,date,link,title,${taxonomy}`, //取得するフィールド
                per_page: perPage, //取得する件数
                [taxonomy]: catId, //カテゴリ一覧の場合カテゴリを指定
                offset: offset //2ページ目以降の場合それまでの記事をスキップ
            }
        };

        // 戻り値
        const r = {
            postsList: [], //記事一覧
            totalNum: 0, //トータル記事数
        }

        // WP REST APIにアクセス
        axios.get(url, config).then(res => {
            // console.log(res.data);
            r.postsList = r.postsList.concat(res.data); //記事情報を格納
            r.totalNum = res.headers['x-wp-total'] - 0; //トータル記事件数を格納
            resolve(r);
            
        // エラー
        }).catch(error => {
            console.log(error);
            reject();

        });
    });
}

export default getNewsList